import { useSelector } from 'react-redux'
import { AppState } from 'redusers/config'

export const useGetSearchSymbol = () => {
  return useSelector((state: AppState) => state.searchSymbolReducer.searchSymbol)
}
